import React, { useState, useEffect } from 'react';
import { Button, Typography } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

interface ActiveAccountProps {
  setCurrentStep: (step: number) => void;
  profileData: any;
  navigate: any;
  setCompletedSteps: (steps: number[]) => void;
  completedSteps: number[];
}

const ActiveAccount: React.FC<ActiveAccountProps> = ({
  setCurrentStep,
  profileData,
  navigate,
  setCompletedSteps,
  completedSteps
}) => {
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    // Auto complete this step
    if (!completedSteps.includes(3)) {
      setCompletedSteps([...completedSteps, 3]);
    }

    // Start countdown
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          handleComplete();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleComplete = () => {
    // Clear registration data and simulate login
    localStorage.removeItem('registrationData');
    // localStorage.setItem('token', 'demo_token_' + Date.now());
    navigate('/accounts-overview');
  };

  return (
    <div className="wallet-setup-step flex flex-col items-center justify-center min-h-[400px] text-center">
      {/* Success Icon */}
      <div className="mb-8">
        <CheckCircleOutlined className="text-8xl !text-green-500" />
      </div>

      {/* Success Message */}
      <div className="mb-4">
        <Title level={2} className="!text-white !mb-2 !font-bold">
          Last step - Account Activated!
        </Title>
        <Text className="!text-gray-300 text-lg block leading-relaxed">
          Your account has been created successfully.
        </Text>
      </div>

      {/* Action Button */}
      <div className="w-full max-w-md">
        <Button
          type="primary"
          size="large"
          onClick={handleComplete}
          className="w-full h-14 bg-green-500 hover:bg-green-600 border-green-500 hover:border-green-600 text-white font-semibold text-lg rounded-lg"
        >
          GO TO YOUR ACCOUNT
        </Button>
        
        {countdown > 0 && (
          <Text className="!text-gray-400 text-sm mt-3 block">
            Redirecting in {countdown} seconds...
          </Text>
        )}
      </div>
    </div>
  );
};

export default ActiveAccount;
